export const FONTS = {
  heading:
    "ivyora-display, ivyora-text, Inter, -apple-system, system-ui, sans-serif",
  headingSmall: "Inter, -apple-system, system-ui, sans-serif",
  body: "Inter, -apple-system, system-ui, sans-serif",
};
